export enum TBetSlipTab {
	BetBuilder = "BB",
	BetSlip = "bet-slip",
}
